import { Box } from "@mui/material";
import { useEffect, useState } from "react";

import { useFormik } from "formik";
import useSWRMutation from "swr/mutation";
import {
  ArmadaInfoFormikValidator,
  loaderInfoFormikValidator,
} from "../../../../formValidators/auth/complete-info";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import {
  setDriverLicensePlate,
  setloaderTypeGroup,
  setVehicleSmartCard,
} from "../../../../redux/features/userSlice";
import { fetcherPost } from "../../../../services/fetcher";
import CustomDialogBox from "../../../components/CustomDialogBox";
import CustomSnackbar from "../../../components/CustomSnackbar";
import ArmadaInfo from "./Steps/ArmadaInfo";
import BankAccountInfo from "./Steps/BankAccountInfo";
import ResidenceInfo from "./Steps/ResidenceInfo";
import UploadDocuments from "./Steps/UploadDocuments";
import { useNavigate } from "react-router-dom";

export default function CompleteInfo() {
  const navigate = useNavigate();
  const [pelakValues, setPelakValues] = useState<{
    licensePlateSerial?: string;
    firstTowDigits?: string;
    alpha?: string;
    lastThiredDigits?: string;
  }>();

  const [loaderTypeInputValue, setloaderTypeInputValue] = useState("");

  const [loaderTypesOptions, setloaderTypesOptions] = useState([]);

  const [disableLoaderGroup, setDisableLoaderGroup] = useState(false);

  const [stepIndex, _setStepIndex] = useState(1);

  const dispatch = useAppDispatch();

  const { trigger: setVehicleDriverTrigger } = useSWRMutation(
    [`/Driver/SetVehicleDriver`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {},
      onError: () => {},
    }
  );

  const {
    trigger: getLoaderInfoTrigger,
    isMutating: isGetLoaderInfoTriggerMutating,
  } = useSWRMutation(
    [`/Vehicle/GetVehicleInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        const { vehicle, loaderGroup } = data;

        setVehicleDriverTrigger({
          input: vehicle.smartCard,
        })
          .then((res) => {
            ArmadaInfoFormik.setFieldValue("smartCard", vehicle.smartCard);
            if (vehicle.loaderTypeName) {
              setDisableLoaderGroup(true);
              ArmadaInfoFormik.setFieldValue("loaderType", {
                label: vehicle.loaderTypeName,
                value: vehicle.loaderTypeCode,
                group: vehicle.loaderTypeGroup || loaderGroup,
              });
            } else {
              ArmadaInfoFormik.setFieldValue("loaderType", null);
            }

            const firstTowDigits = vehicle.licensePlateNr.slice(4, 6);
            const lastThiredDigits = vehicle.licensePlateNr.slice(0, 3);
            const alpha = vehicle.licensePlateNr.slice(3, 4);
            setPelakValues({
              alpha,
              firstTowDigits,
              lastThiredDigits,
              licensePlateSerial: vehicle.licensePlateSerial,
            });
            dispatch(
              setDriverLicensePlate({
                alpha,
                firstTowDigits,
                lastThiredDigits,
                licensePlateSerial: vehicle.licensePlateSerial,
              })
            );
          })
          .catch((e) => {
            const { data } = e.response;
            if (data.error) {
              dispatch(setOpenSnackbar(true));
              dispatch(setSnackbarErrorStatus(data.errorCode));
              dispatch(setSnackbarDescription(data.error));
            }
          });
      },
    }
  );
  const { trigger: postEditVehicleTrigger } = useSWRMutation(
    [`/Vehicle/EditVehicle`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("اطلاعات با موفقیت ثبت شد!"));
        dispatch(setDialogDescription("...درحال انتقال به صفحه اصلی"));
        dispatch(
          setloaderTypeGroup(
            ArmadaInfoFormik.values.loaderType
              ? ArmadaInfoFormik.values.loaderType["group"]
              : ""
          )
        );

        dispatch(setVehicleSmartCard(ArmadaInfoFormik.values.smartCard));

        setTimeout(() => {
          dispatch(setOpenDialog(false));
          dispatch(setDialogDescription(""));
          navigate("/driver/dashboard");
        }, 4000);
      },
    }
  );

  const loaderInfoFormik = useFormik({
    initialValues: {
      smartCard: "",
    },
    validationSchema: loaderInfoFormikValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      getLoaderInfoTrigger(values);
    },
  });

  const ArmadaInfoFormik = useFormik({
    initialValues: {
      smartCard: loaderInfoFormik.values.smartCard || "",
      loaderType: null,
    },
    validationSchema: ArmadaInfoFormikValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      postEditVehicleTrigger({
        LoaderTypeCode: values.loaderType && values.loaderType["value"],
        vehicleSmartCard: values.smartCard,
      });
    },
  });

  const { trigger: getLoaderTypesTrigger } = useSWRMutation(
    [`/LoaderType/SearchByName`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setloaderTypesOptions((prev) =>
          data.map((item: any) => ({
            label: item.name,
            value: item.code,
          }))
        );
      },
    }
  );

  const handleChangeAutoComplete = (
    selected: any,
    type: string | undefined
  ) => {
    switch (type) {
      case "loaderType":
        ArmadaInfoFormik.setFieldValue("loaderType", selected);
        break;
      case "destination":
        ArmadaInfoFormik.setFieldValue("destination", selected);
        break;

      default:
        break;
    }
  };

  function getForm(index: number) {
    switch (index) {
      case 1:
        return (
          <ArmadaInfo
            inquarySmartCardFormik={ArmadaInfoFormik}
            smartCard={{
              name: "smartCard",
              value: loaderInfoFormik.values.smartCard,
              handleChange: loaderInfoFormik.handleChange,
              error:
                (loaderInfoFormik.touched.smartCard &&
                  Boolean(loaderInfoFormik.errors.smartCard)) ||
                (ArmadaInfoFormik.touched.smartCard &&
                  Boolean(ArmadaInfoFormik.errors.smartCard)),
              errorMessage:
                (loaderInfoFormik.touched.smartCard &&
                  loaderInfoFormik.errors.smartCard) ||
                (ArmadaInfoFormik.touched.smartCard &&
                  ArmadaInfoFormik.errors.smartCard),
              loading: isGetLoaderInfoTriggerMutating,
              disabled: !!ArmadaInfoFormik.values.smartCard.length,
            }}
            loaderType={{
              autoCompleteType: "loaderType",
              autoCompleteSelected: ArmadaInfoFormik.values.loaderType,
              handleChangeInput: setloaderTypeInputValue,
              inputValue: loaderTypeInputValue,
              options: loaderTypeInputValue ? loaderTypesOptions : [],
              disabled: disableLoaderGroup,
              error:
                ArmadaInfoFormik.touched.loaderType &&
                Boolean(ArmadaInfoFormik.errors.loaderType),
              errorMessage:
                ArmadaInfoFormik.touched.loaderType &&
                ArmadaInfoFormik.errors.loaderType,
            }}
            loaderTypeGroup={{
              value:
                ArmadaInfoFormik.values.loaderType &&
                ArmadaInfoFormik.values.loaderType["group"],
            }}
            pelakValues={pelakValues}
            handleChangeAutoComplete={handleChangeAutoComplete}
            handleChangeInput={ArmadaInfoFormik.handleChange}
            handleSubmitArmadaInfoForm={ArmadaInfoFormik.handleSubmit}
            handleSubmitLoaderInfoForm={loaderInfoFormik.handleSubmit}
          />
        );
      case 2:
        return <UploadDocuments />;
      case 3:
        return <ResidenceInfo />;
      case 4:
        return <BankAccountInfo />;

      default:
        break;
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      loaderTypeInputValue &&
        getLoaderTypesTrigger({
          name: loaderTypeInputValue || null,
        })
          .then((data) => {
            setloaderTypesOptions((prev) =>
              data.map((item: any) => ({
                label: item.name,
                value: item.code,
                group: item.group,
              }))
            );
          })
          .catch((e) => {
            console.log(e);
          });
    }, 1000);
    return () => clearTimeout(timer);
  }, [loaderTypeInputValue]);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "bgColor.grey100",
          height: "100vh",
          overflow: "auto",
          paddingX: "8px",
        }}
      >
        <CustomSnackbar />
        <CustomDialogBox />
        {getForm(stepIndex)}
      </Box>
    </>
  );
}
